angular.module('rightPaneModule')
  .service('tableColumns', [function () {
      var publics = {};

      var teacherColumns_fractions = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'percent_active_students',
          name: 'Avg Active Students',
          filter: 'percent',
          sortType: 'numeric',
          sortOrder: 'desc',
          default: true
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'average_weekly_lessons',
          name: 'Avg Lessons/Wk',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'standards_growth',
          name: 'Avg Standards Proficient',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }];

      //Columns used for every list-table except for those displaying students with completion (single item inside, hence NO Avg in header)
      var itemColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'grade',
          name: 'Grade Level',
          filter: 'grade',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_session_time',
          name: 'Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_lessons',
          name: 'Lessons/Wk',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_partial_growth',
          name: 'Standards Progressed In',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric'
      }];

      var itemColumns_fractions = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'grade',
          name: 'Grade Level',
          filter: 'grade',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_session_time',
          name: 'Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_lessons',
          name: 'Lessons/Wk',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_partial_growth',
          name: 'Standards Progressed In',
          filter: 'number',
          sortType: 'numeric'
      }];

      // Modifying classroomsColumns also affects classroomsColumnsWithGrowth
      var classroomsColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'name',
          name: 'Classroom',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'percent_active_students',
          name: 'Avg Active Students',
          filter: 'percent',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_lessons',
          name: 'Avg Lessons/Wk',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Avg Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }];

      var classroomsColumnsWithGrowth = _.clone(classroomsColumns);
      classroomsColumnsWithGrowth.splice(
          classroomsColumns.length - 1, // add growth as second to last column
          0,
          {
              id: 'percent_growth',
              name: 'Growth',
              filter: 'percent',
              sortType: 'numeric'
          }
      );

      var gradesColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'name',
          name: 'Grade',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'percent_active_students',
          name: 'Avg Active Students',
          filter: 'percent',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_lessons',
          name: 'Avg Lessons/Wk',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Avg Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }];

      var schoolsColumns_fractions = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'name',
          name: 'Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'percent_active_students',
          name: 'Avg Active Students',
          filter: 'percent',
          sortType: 'numeric',
          sortOrder: 'desc',
          default: true
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'average_weekly_lessons',
          name: 'Avg Lessons/Wk',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'standards_growth',
          name: 'Avg Standards Proficient',
          filter: 'number',
          sortType: 'numeric',
          sortOrder: 'desc'
      }];

      var studentCompletionColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'average_weekly_session_time',
          name: 'Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      },{
          id: 'standards_growth',
          name: 'Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_partial_growth',
          name: 'Standards Progressed In',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric'
      }];

      var studentCompletionFractionModeColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'average_weekly_session_time',
          name: 'Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'total_session_time',
          name: 'Total Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric',
          sortOrder: 'desc'
      }, {
          id: 'count_lessons_completed',
          name: 'Lessons Completed',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'standards_partial_growth',
          name: 'Standards Progressed In',
          filter: 'number',
          sortType: 'numeric'
      }];

      var schoolsColumnsPerformance_fractions = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'name',
          name: 'Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'percent_active_students',
          name: 'Avg Active Students',
          filter: 'percent',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'nullableMinutes',
          sortType: 'numeric'
      }, {
          id: 'usage_extended_hours',
          name: 'Out of School Time',
          filter: 'totalTime',
          sortType: 'numeric'
      }, {
          id: 'average_weekly_lessons',
          name: 'Avg Lessons/Wk',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric'
      }, {
          id: 'standards_growth',
          name: 'Avg Standards Proficient',
          filter: 'number',
          sortType: 'numeric'
      }];

      var bubbleGraphColumns = [{
          id: 'status',
          name: 'Status'
      }, {
          id: 'name',
          name: 'Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'average_weekly_session_time',
          name: 'Avg Min/Wk',
          filter: 'minutes',
          sortType: 'numeric'
      }, {
          id: 'percent_growth',
          name: 'Growth',
          filter: 'percent',
          sortType: 'numeric'
      }];

      var schoolsCustomerUsageColumns = [
      {
          id: 'status',
          name: 'Status'
      }, {
          id: 'schoolName',
          name: 'Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'active_customers',
          name: 'Active Teachers',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'active_sessions',
          name: 'Total Sessions',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'percent_active_customers',
          name: 'Percent Active',
          filter: 'percent',
          sortType: 'numeric'
     }];

      var teachersCustomerUsageColumns = [
      {
          id: 'status',
          name: 'Status'
      }, {
          id: 'first_name',
          name: 'First Name',
          filter: 'name',
          sortType: 'text'
      }, {
          id: 'last_name',
          name: 'Last Name',
          filter: 'name',
          sortType: 'text'
     }, {
          id: 'session_count',
          name: 'Total Sessions',
          filter: 'number',
          sortType: 'numeric'
      }, {
          id: 'usage_time_in_min',
          name: 'Total Usage (Min)',
          displayFilter: 'number:1',
          sortType: 'numeric'
      }, {
          id: 'usage_time_per_session',
          name: 'Average Usage (Min)',
          displayFilter: 'number:1',
          sortType: 'numeric'
     }];

      publics.getColumns = function (type) {
          switch (type) {
              case 'district':
                  return []; //Doesn't make sense
              case 'grade':
                  return gradesColumns;
              case 'school_fractions':
                  return schoolsColumns_fractions;
              case 'schoolPerformance_fractions':
                  return schoolsColumnsPerformance_fractions;
              case 'teacher_fractions':
                  return teacherColumns_fractions;
              case 'classroom':
                  return classroomsColumns;
              case 'classroom_with_growth':
                  return classroomsColumnsWithGrowth;
              case 'schoolsCustomerUsage':
                  return schoolsCustomerUsageColumns;
              case 'teacherCustomerUsage':
                  return teachersCustomerUsageColumns;
              case 'student':
                  return itemColumns;
              case 'student_fractions':
                  return itemColumns_fractions;
              case 'studentCompletion':
                  return studentCompletionColumns;
              case 'studentCompletionFractionMode':
                  return studentCompletionFractionModeColumns;
              case 'bubbleGraph':
                  return bubbleGraphColumns;
              default:
                  return [];
          }
      };

      return publics;

  }]);
